/**
 * The Brij mark as an agent avatar — what every agent wears where the brand has
 * no avatar template sets (`brand.agentAvatars.textures`), Segev's Option C of
 * docs/BRIJ_AGENT_AVATARS_DESIGN.html (2026-11-01): the mark's own three-stop
 * gradient, re-tinted per colour, on a white disc (dark surface in dark mode).
 *
 * Brand-layer data: `default.ts` carries it as `agentAvatars.mark`, a brand may
 * set its own, and `agent-avatars.ts` draws it. `path` / `viewBox` are
 * brand-assets/brij/mark.svg's; `gradient` is the mark's own gradient vector in
 * those units. Each colour's `base` is what the Edit Agent picker stores on the
 * agent; the first colour is the mark's original gradient (pinned by
 * tests/unit/brand/agent_avatars.test.mjs).
 */

import type { BrandAgentMark } from './types';

export const BRIJ_AGENT_MARK: BrandAgentMark = {
  path: 'M132.147 54.3473C132.036 54.9574 131.886 55.5657 131.691 56.1676L111.71 117.661C109.853 123.378 104.525 127.249 98.5139 127.249H33.8567C29.5305 127.249 25.5591 125.243 22.9798 121.988C59.3687 99.4413 95.7577 76.8939 132.147 54.3473ZM58.0296 2.65C62.8928 -0.883352 69.4778 -0.883312 74.3411 2.65L126.651 40.6539C127.535 41.2963 128.324 42.0304 129.015 42.8336C88.8972 55.4665 48.7791 68.0991 8.66139 80.732L0.679949 56.1676C-1.17752 50.4505 0.857771 44.1872 5.72096 40.6539L58.0296 2.65Z',
  viewBox: '0 0 132.147 127.249',
  gradient: [-12, 144, 141, 41],
  colors: [
    { base: '#98C6E7', stops: ['#98C6E7', '#D8E094', '#FFC258'] }, // Brij (the original)
    { base: '#4F9FD6', stops: ['#7CC0EC', '#4F9FD6', '#2F78B8'] }, // Sky
    { base: '#8FAE5B', stops: ['#C9DB8E', '#9DBA62', '#6F9443'] }, // Sage
    { base: '#D4A853', stops: ['#FFD58A', '#E8B65E', '#C99234'] }, // Gold
    { base: '#E27D6A', stops: ['#F7B39F', '#E88A73', '#C9604C'] }, // Coral
    { base: '#9277C8', stops: ['#C2B0EA', '#9C82D2', '#7458B0'] }, // Plum
    { base: '#3BA99C', stops: ['#86D6C9', '#45B3A5', '#2A8A7E'] }, // Teal
    { base: '#6B7A90', stops: ['#A9B5C6', '#7887A0', '#55637A'] }, // Slate
  ],
};
